import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import * as queryString from 'query-string';

import AdWrapper from '../../components/Ads/AdWrapper';
import Login from './Login';
import LinkedAccountExistsPopup from '../../components/Popup/LinkedAccountExistsPopup';
import { hideSplash } from '../../actions/splash-actions';
import { useAuthErrorPopup } from '../../hooks/useAuthErrorPopup';
import useIsMobile from '../../components/hooks/useIsMobile';
import { useAdDynamicConfig } from '../../components/hooks/useAdDynamicConfig';
import { AdTypes } from '../../utils/types';
import styles from './Login/login.scss';
import head from '../../components/Meta';
import config from '../../../config';

const LoginPage = () => {
    const { showAds, signInConfig } = useAdDynamicConfig();
    const { isMobileWidth, isTabletWidth } = useIsMobile();
    const user = useSelector((state) => state?.auth?.user);
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const parsed = queryString.parse(location.search);
    const { showLinkedAccountExistsPopup, dismissLinkedAccountExistsPopup } = useAuthErrorPopup(parsed?.error);

    useEffect(() => {
        if (user) {
            dispatch(hideSplash());
            history.replace('/home'); // Go to dashboard if logged in
        }
    }, []);

    const handleLinkedAccountCancelClick = dismissLinkedAccountExistsPopup;

    const email = parsed?.email || '';
    const showMobileAds = showAds && isMobileWidth && signInConfig?.showRectangle;
    const showTabletAds = showAds && isTabletWidth && signInConfig?.showRectangle;
    const showDesktopAds = showAds && !isMobileWidth && !isTabletWidth && signInConfig?.showSkyscraper;

    const renderLogin = () => {
        if (showDesktopAds) {
            return (
                <div className="container">
                    <div className={styles.wrapper}>
                        <div className={styles.skyscraperAdContainer}>
                            <AdWrapper type={AdTypes.SKYSCRAPER_LEFT} data-testid="login.ad.skyscraper-left" />
                        </div>
                        <div className={styles.formWrapper}>
                            <Login
                                history={history}
                                location={location}
                                email={email}
                            />
                        </div>
                        <div className={styles.skyscraperAdContainer}>
                            <AdWrapper type={AdTypes.SKYSCRAPER_RIGHT} data-testid="login.ad.skyscraper-right" />
                        </div>
                    </div>
                </div>
            );
        }

        if (showMobileAds || showTabletAds) {
            return (
                <div className="container">
                    {showMobileAds && (
                        <div className={styles.leaderboardMobileAdContainer}>
                            <AdWrapper type={AdTypes.LEADERBOARD_ONE} data-testid="login.ad.mobile-leaderboard" />
                        </div>
                    )}
                    <Login
                        history={history}
                        location={location}
                        email={email}

                    />
                    {showMobileAds ? (
                        <div className={styles.rectangleMobileAdContainer}>
                            <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="login.ad.mobile-rectangle" />
                        </div>
                    ) : (
                        <div className={styles.rectangleTabletAdContainer}>
                            <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="login.ad.tablet-rectangle-1" />
                            <AdWrapper type={AdTypes.RECTANGLE_TWO} data-testid="login.ad.tablet-rectangle-2" />
                        </div>
                    )}
                </div>
            );
        }
        return (
            <Login
                history={history}
                location={location}
                email={email}
            />
        );
    };

    return (
        <div>
            {head({
                title: `Sign In | UTR Sports`,
                image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                imageWidth: '930',
                imageHeight: '395',
            })}
            {renderLogin()}
            {showLinkedAccountExistsPopup && (
                <LinkedAccountExistsPopup
                    onCancelClick={handleLinkedAccountCancelClick}
                />
            )}
        </div>
    );
};

export default LoginPage;
